import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-section-promise',
  templateUrl: './section-promise.component.html',
  styleUrls: ['./section-promise.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionPromiseComponent {
  constructor() {}
}
